// extracted by mini-css-extract-plugin
module.exports = {"StoryCardLink":"StoryCardLink_StoryCardLink__fT2Uv","StoryCardLink__icon":"StoryCardLink_StoryCardLink__icon__sRmT_"};